import { Grid } from "@mui/material";
import { ManagementTableHeader } from "../components/Management/ManagementTableHeader";
import { CreateEditModal } from "../components/Management/components/CreateEditModalBox";
import { InviteModal } from "../components/Management/components/InviteModalBox";
import { ManagementType } from "types/common";
import { Clinician } from "types/Clinician";
import { userOperations, USER_GROUPS } from "constants/roles";
import { useEffect, useState } from "react";
import { ManagementTableRow } from "../components/Management/ManagementTableRow";
import { Loading } from "../../../components/Loading/Loading";
import { useAppSelector, useAppDispatch } from "hooks/reduxHooks";
import {
  selectCurrentClinicianList,
  selectCurrentClinicianPatients,
} from "store/ClinicianStore/selectors";
import { InviteResultModal } from "pages/auth/InviteResultModal";
import { selectCurrentClinicPatientsList } from "store/PatientStore/selectors";
import { Patient } from "types/Patient";
import { FilterModal } from "components/FilterModal/FilterModal";
import { FilterType } from "constants/types";
import HeaderModalsByTab from "../components/Management/components/HeaderModalsByTab";
import HeaderActionsByTab from "../components/Management/components/HeaderActionsByTab";
import PaginationByRole from "../components/Management/components/PaginationByRole";
import {
  getClinicianPatientsList,
  getClinicRecoveryTemplates,
} from "store/ClinicianStore/actions";

type Props = {
  onClick?: any;
  onClickClinicianPatients?: any;
  sortConfig: any;
  onLoadMore: any;
  onLoadMorePatients: any;
  onLoadMoreClinicianPatients: any;
  onClickClinicPatients: any;
  hasMorePatients: boolean;
  currentClinician: Clinician;
  managementType?: ManagementType;
  hasMoreClinicianPatients: boolean;
  clinicianPatientsLoading: any;
  clinicPatientsLoading: any;
};

export const ContainerForCliniciansOtherRoles = ({
  onClick,
  onClickClinicianPatients,
  onClickClinicPatients,
  sortConfig,
  onLoadMore,
  onLoadMorePatients,
  onLoadMoreClinicianPatients,
  currentClinician,
  managementType,
  hasMorePatients,
  hasMoreClinicianPatients,
  clinicianPatientsLoading,
  clinicPatientsLoading,
}: Props) => {
  const dispatch = useAppDispatch();
  const [openCreateEditModal, setOpenCreateEditModal] =
    useState<boolean>(false);
  const [openInviteModal, setOpenInviteModal] = useState<boolean>(false);
  const currentClinicianList: Clinician[] | undefined = useAppSelector(
    selectCurrentClinicianList
  );

  const currentClinicianPatientsList: Patient[] | undefined = useAppSelector(
    selectCurrentClinicianPatients
  );
  const currentClinicPatientsList: Patient[] | undefined = useAppSelector(
    selectCurrentClinicPatientsList
  );

  const [dataList, setDataList] = useState<Patient[] | Clinician[] | []>([]);
  const [createEditOperation, setCreateEditOperation] =
    useState<userOperations>(userOperations.CREATE);
  const openCreateEditModalWithOperation = (
    isCreateEditModalEnabled: boolean,
    operationType: userOperations
  ) => {
    setCreateEditOperation(operationType);
    setOpenCreateEditModal(isCreateEditModalEnabled);
  };
  const [open, setOpen] = useState(false);
  const [isError, setError] = useState(false);
  const [openFilterModal, setOpenFilterModal] = useState<boolean>(false);
  const [openInviteFilterModal, setOpenInviteFilterModal] =
    useState<boolean>(false);
  const isPatientCare = managementType === ManagementType.PATIENT_CARE;
  const isPatientList = managementType === ManagementType.PATIENT;
  const isUserList = managementType === ManagementType.USER;

  const getTitleByRole = () => {
    if (managementType == ManagementType.USER) {
      return "Users List";
    } else if (managementType == ManagementType.PATIENT) {
      if (currentClinician?.role?.includes(USER_GROUPS.CLINIC_ASSISTANT)) {
        return "Patient Team Lead Assignment";
      } else if (
        currentClinician?.role?.includes(USER_GROUPS.CLINIC_TEAM_LEAD)
      ) {
        return "Patient Team Assignment";
      }
    } else if (managementType == ManagementType.PATIENT_CARE) {
      return "My Assigned Patients";
    } else {
      return "";
    }
  };

  useEffect(() => {
    getDataByType();
  }, [
    currentClinicianList,
    currentClinicianPatientsList,
    currentClinicPatientsList,
  ]);

  const getDataByType = () => {
    const leadAndAssistantRoles = [USER_GROUPS.CLINIC_ASSISTANT];
    const isAssistant = currentClinician?.role?.some((role) =>
      leadAndAssistantRoles.includes(role)
    );

    const isLead = currentClinician?.role?.includes(
      USER_GROUPS.CLINIC_TEAM_LEAD
    );

    const isClinician = currentClinician?.role?.includes(USER_GROUPS.CLINICIAN);
    console.log({
      isUserList,
      currentClinicianList,
      isAssistant,
      isPatientList,
      isLead,
      isClinician,
      isPatientCare,
      currentClinicianPatientsList,
    });
    if (isUserList && currentClinicianList) {
      return setDataList(currentClinicianList);
    }

    if (isAssistant && isPatientList) {
      return setDataList(currentClinicPatientsList);
    }

    if (isLead && isPatientList && currentClinicPatientsList) {
      return setDataList(currentClinicPatientsList);
    }

    if (isClinician && isPatientCare && currentClinicianPatientsList) {
      return setDataList(currentClinicianPatientsList);
    }
  };

  const getLoading = () => {
    if (managementType === ManagementType.PATIENT_CARE) {
      return clinicianPatientsLoading || clinicPatientsLoading;
    }
    if (managementType === ManagementType.PATIENT) {
      return clinicPatientsLoading;
    }
    return clinicianPatientsLoading;
  };

  useEffect(() => {
    dispatch(getClinicianPatientsList(currentClinician._id));
    dispatch(getClinicRecoveryTemplates(currentClinician.clinicId));
  }, []);

  return (
    <>
      <Grid
        container
        style={{ marginBottom: 18, justifyContent: "space-between" }}
      >
        <Grid item ml={6} p={0} m={0}>
          <Grid
            sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}
          >
            <h2 style={{ marginRight: 12 }}>{getTitleByRole()}</h2>
            <HeaderModalsByTab
              managementType={managementType}
              setOpenFilterModal={setOpenFilterModal}
              currentClinician={currentClinician}
              setOpenInviteFilterModal={setOpenInviteFilterModal}
              openInviteFilterModal={openInviteFilterModal}
            />
          </Grid>
        </Grid>
        <Grid item ml={6} p={0} m={0}>
          <Grid container gap={2}>
            <HeaderActionsByTab
              managementType={managementType}
              openCreateEditModalWithOperation={
                openCreateEditModalWithOperation
              }
              currentClinician={currentClinician}
              setOpenInviteModal={setOpenInviteModal}
              openFilterModal={openFilterModal}
              setOpenFilterModal={setOpenFilterModal}
            />
          </Grid>
        </Grid>
      </Grid>
      {isPatientCare && (
        <FilterModal
          isEnabled={openFilterModal}
          setIsEnabled={setOpenFilterModal}
          operation={FilterType.PATIENT_FILTER}
          currentClinician={currentClinician}
        />
      )}
      <ManagementTableHeader
        onClick={onClick}
        onClickClinicianPatients={onClickClinicianPatients}
        onClickClinicPatients={onClickClinicPatients}
        sortConfig={sortConfig}
        managementType={managementType}
      />
      <div
        className="w-full min-h-[200px] flex flex-col overflow-y-hidden space-y-[5px] relative"
        style={
          !currentClinician?.role?.includes(USER_GROUPS.CLINICIAN) &&
          isPatientCare
            ? { pointerEvents: "none" }
            : {}
        }
      >
        {!dataList || dataList.length === 0 ? (
          <div style={{ marginTop: "5%", textAlign: "center", color: "#999" }}>
            No data available
          </div>
        ) : (
          dataList.map((user: any, index) => (
            <ManagementTableRow
              key={index}
              user={user}
              managementType={managementType}
              openCreateEditModalOperation={openCreateEditModalWithOperation}
            />
          ))
        )}
        <Loading loading={getLoading()} states={dataList} />
      </div>
      <PaginationByRole
        currentClinician={currentClinician}
        managementType={managementType}
        clinicPatientsLoading={clinicPatientsLoading}
        hasMorePatients={hasMorePatients}
        onLoadMorePatients={onLoadMorePatients}
        clinicianPatientsLoading={clinicianPatientsLoading}
        hasMoreClinicianPatients={hasMoreClinicianPatients}
        onLoadMoreClinicianPatients={onLoadMoreClinicianPatients}
        loading={clinicianPatientsLoading}
        onLoadMore={onLoadMore}
      />
      {
        <CreateEditModal
          isEnabled={openCreateEditModal}
          setIsEnabled={setOpenCreateEditModal}
          operation={createEditOperation}
          setOpen={setOpen}
          setError={setError}
        />
      }
      {
        <InviteModal
          isEnabled={openInviteModal}
          setIsEnabled={setOpenInviteModal}
        />
      }
      {<InviteResultModal open={open} setOpen={setOpen} isError={isError} />}
    </>
  );
};
